import { useEffect } from 'react';
import { useRoute } from '@/router';
import { getRouteMeta } from '@/data/site';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import MenuPage from '@/pages/Menu';
import Tentang from '@/pages/Tentang';
import Faq from '@/pages/Faq';
import NotFound from '@/pages/NotFound';

function pageFor(path) {
  const p = path !== '/' && !path.endsWith('/') ? path + '/' : path;
  switch (p) {
    case '/':
      return <Home />;
    case '/menu/':
      return <MenuPage />;
    case '/tentang/':
      return <Tentang />;
    case '/faq/':
      return <Faq />;
    default:
      return <NotFound />;
  }
}

export default function App() {
  const { path } = useRoute();

  useEffect(() => {
    const meta = getRouteMeta(path);
    document.title = meta.title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', meta.description);
  }, [path]);

  return (
    <div className="min-h-screen bg-santan font-sans text-charcoal">
      <Header />
      <main id="konten-utama">{pageFor(path)}</main>
      <Footer />
    </div>
  );
}
